<template>
  <div>
        <ctop />
        <cswiper />
        <search />
        <div class="c_content">
            <div class="crumbs">
                <div class="border"></div>
                <div class="now">当前位置：</div>
                <div class="one">新闻中心</div>
            </div>

            <div class="q_content">
                
                <div class="content_l">

                    <div class="new_option">
                        <div class="title">{{listname}}</div>
                        <div class="list" @click="getcase(0)">
                            <span>活动策划</span>
                            <img src="~@/assets/new_h.png">
                        </div>
                        <div class="list" @click="getcase(9)">
                            <span>中山风景</span>
                            <img src="~@/assets/new_h.png">
                        </div>
                    </div>

                    <!-- service -->
                    <div class="service">
                        <img src="~@/assets/service.png">
                        <div class="content">
                            <div class="name">中一广告策划</div>
                            <div class="list">
                                <span>电 话：</span>
                                <span>0760-88929118</span>
                            </div>
                            <div class="list">
                                <span>手   机：</span>
                                <span>18022118773</span>
                            </div>
                            <div class="list">
                                <span>邮   箱：</span>
                                <div class="right">
                                    <span>1694138860@qq.com</span>
                                    <span>chinaone_zs@126.com</span>
                                </div>
                            </div>
                            <div class="list">
                                <span class="title">地   址：</span>
                                <span class="add">中山市兴中道28号中山体育场附近</span>
                            </div>
                        </div>
                        <div class="lianxi">
                            <img src="~@/assets/kefu.png">
                            <span>联系客服</span>
                        </div>
                    </div>


                </div>

                <div class="content_r">
                    <div class="r_title">
                        <!-- <img src="~@/assets/lujing.png"> -->
                    </div>
                    <div class="name">
                        {{listname}}
                    </div>

                    <div class="content_list">

                        <div class="content_name">
                            {{caseinfo.name}}
                        </div>
                        <div class="option">
                            <!-- <div class="list">
                                <span class="tl">项目类型：</span>
                                <span class="co">品牌策划</span>
                            </div> -->
                            <div class="list">
                                <span class="tl">发布时间：</span>
                                <span class="co">{{caseinfo.create_time}}</span>
                            </div>
                            <!-- <div class="list">
                                <span class="tl">项目场地：</span>
                                <span class="co">上海中心大厦朵云书院</span>
                            </div> -->
                        </div>
                        
                        <div class="n_content" v-html="caseinfo.content">
                            
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="mar"></div>
        <bottom />
        <right />
  </div>
</template>

<script>
import ctop from '@/components/ctop'
import cswiper from '@/components/cswiper'
import search from '@/components/search'
import bottom from '@/components/bottom'
import right from '@/components/right'
export default {
  name: 'Home',
  components: {
      cswiper,
      ctop,
      search,
      bottom,
        right
  },
  data () {
    return {
       currentPage3: 5,
       listname:'',
       id:'',
       sid:'',
       caseinfo:''
    }
  },
  computed: {
    
  },
  created: function () {
      this.id = this.$route.query.id
      this.sid = this.$route.query.sid
      if(this.sid == 0){
          this.listname = '活动策划'
      }else if(this.sid == 9){
        this.listname = '中山风景'
        }
      console.log(this.id)
  },
  mounted() {
    
  },
  mounted() {
    this.getcaseinfo()
  },
  methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        getcase(id){
          if(id == 0){
            //   this.listname = '活动策划'
            this.$router.push('/news?url=news&sid=0');
          }else if(id == 9){
            //   this.listname = '中山风景'
            this.$router.push('/news?url=news&sid=9');
          }
          
        },
        getcaseinfo(){
            this.$http.post('/api/casecontent/content',this.$qs.stringify({id:this.id})).then((res)=>{
                let callback = res.data
                if(callback.code == 200){
                    this.caseinfo = callback.data
                }
            }).catch((error) => {
                console.log('获取失败')
            })
        }
  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;

.c_content{
    width: 100%;
    padding:0 75px;
    box-sizing: border-box;
}
.crumbs{
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    align-items: center;
    .border{
        height: 20px;
        width: 5px;
        background: #CF2C2E;
        border-radius: 5px;
        margin:0 20px 0 65px;
    }
    .fu{
        margin:0 5px;
    }
}
.q_content{
    display: flex;
    justify-content: space-between;
    margin-top:80px;
    .content_l{
        width: 20%;
        box-sizing: border-box;
        margin-bottom:40px;
        .new_option{
            border-radius: 10px;
            border:1px solid #a1a1a1;
            .title{
                border-radius: 10px 10px 0 0;
                background: #CF2C2E;
                color:#fff;
                font-size: 20px;
                padding:20px 0;
            }
            .list{
                font-size: 20px;
                padding:20px 0;
                display: flex;
                justify-content: center;
                align-items: center;
                border-top:1px solid #a1a1a1;
                cursor: pointer;
                img{
                    width: 25px;
                    height: 25px;
                    margin-left: 10px;
                }
            }
        }
    }
    .content_r{
        width: 75%;
        .r_title{
            width: 100%;
            height: 5px;
            background: #CF2C2E;
            // img{
            //     width: 100;
                
            // }
        }
        .name{
            width: 252px;
            height: 53px;
            background: url('~@/assets/lujing.png') no-repeat;
            display: flex;
            justify-items: center;
            align-items: center;
            color: #fff;
            padding-left: 20px;
            padding-bottom: 5px;
            box-sizing: border-box;
        }
        .content_list{
            display: flex;
            flex-direction: column;
            
            .content_name{
                color:#222;
                font-size: 24px;
                margin-top:60px;
                margin-bottom: 60px;
            }
            .n_content{
                width: 100%;
                overflow: hidden;
                margin-top:30px;
                /deep/ img{
                    width: 100%;
                }
            }
            .option{
                width: 100%;
                border-bottom: 1px solid #a1a1a1;
                padding-bottom: 20px;
                display: flex;
                .list{
                   margin-right: 50px;
                }
            }
        }
    }
}

.service{
    width: 100%;
    margin-top:40px;
    display: flex;
    flex-direction: column;
    text-align: left;
    border:1px solid #a1a1a1;
    justify-content: center;
    align-items: center;
    .content{
        width: 100%;
        padding:0 10px;
        
        box-sizing: border-box;
    }
    img{
        width: 100%;
        height: 200px;
    }
    .name{
        font-weight: bold;
        padding:15px 0;
    }
    .list{
        margin-bottom:10px;
        border-top:1px solid #a1a1a1;
        padding:10px 0 0 0;
        display: flex;
        align-items: center;
        span:nth-child(1){
            width: 30%;
        }
        .right{
            width: 70%;
            display: flex;
            flex-direction: column;
        }
    }
    .lianxi{
        width: 240px;
        // height: 50px;
        background: #CF2C2E;
        color: #fff;
        margin:30px 0;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding:5px 0;
        img{
            width: 30px;
            height: 30px;
        }
    }
}

.mar{
    width: 100%;
    height: 100px;
}
</style>
